import './main.scss'

import hyperform from 'hyperform'
hyperform(window)
import 'whatwg-fetch'

import 'bootstrap'
import $ from 'jquery'

import './didlogin/main.js'
import './contact/main.js'
import './pricing/main.js'
import './premium/main.js'
import './premium/active-packages/main.js'
import './premium/order/main.js'
import './premium/pending-orders/main.js'
import './u/inbox/main.js'
import './u/referral/main.js'
import './u/unsubscribe/main.js'
import './u/reset-password/main.js'
import './u/order/list/main.js'
import './u/order/view/main.js'
import './u/package/list/main.js'
import './download/main.js'
import './footer.js'
import './header.js'

// home
$(init)
$(window).on('load', onload)
function init () {
  $('#landing-page .download-links .download-link').on('click', ($evt) => {
    try {
      gtag('event', 'clickdownload')
    } catch (err) {
      console.warn('GA event error: ', err)
    }
    /*
    if (!$('body').hasClass('user-loggedin')) {
      $evt.preventDefault()
      $(document).trigger('x-show-register-modal', { redirect: $evt.target.href })
    }
    */
  })
}
function onload () {
  setTimeout(() => {
    $('.video-iframe').each(function () {
      if ($(this).data('src')) {
        this.src = $(this).data('src')
      }
    })
  }, 2500)
}
